export namespace Ui {
	export class ToggleSidebar {
		static readonly type = "[UI] Toggle Sidebar";
	}
}
